import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "modal-container show" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "blocker" }, null, -1)
const _hoisted_3 = {
  key: 0,
  class: "loading"
}
const _hoisted_4 = /*#__PURE__*/_createElementVNode("div", { class: "loading-pulse" }, null, -1)
const _hoisted_5 = [
  _hoisted_4
]
const _hoisted_6 = {
  key: 1,
  class: "modal",
  style: {"width":"720px"}
}
const _hoisted_7 = /*#__PURE__*/_createElementVNode("div", { class: "modal__header modal__header--success justify--flex-start" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "fa fa-shopping-cart ma--right-1" }),
  /*#__PURE__*/_createElementVNode("h3", { class: "modal__header--title" }, "Add Subscription")
], -1)
const _hoisted_8 = { class: "modal__content ma--top-1" }
const _hoisted_9 = { class: "row form-group--checkbox" }
const _hoisted_10 = { class: "form-checkbox" }
const _hoisted_11 = ["id", "checked", "onClick", "disabled"]
const _hoisted_12 = ["for"]
const _hoisted_13 = /*#__PURE__*/_createElementVNode("span", {
  class: "text--style-italic",
  style: {"font-size":"80%"}
}, "$250", -1)
const _hoisted_14 = { class: "modal__footer" }
const _hoisted_15 = ["disabled"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_stripe_checkout = _resolveComponent("stripe-checkout")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    (_ctx.loading || !_ctx.hasBasePlan)
      ? (_openBlock(), _createElementBlock("div", _hoisted_3, _hoisted_5))
      : _createCommentVNode("", true),
    (_ctx.hasBasePlan)
      ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
          _hoisted_7,
          _createElementVNode("div", _hoisted_8, [
            _createElementVNode("div", _hoisted_9, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.products.filter((p) => !p.isBasePlan), (item, index) => {
                return (_openBlock(), _createElementBlock("div", {
                  key: index,
                  class: "pa--x-0 pa--bottom-1 col-6"
                }, [
                  _createElementVNode("div", _hoisted_10, [
                    _createElementVNode("input", {
                      id: 'field-' + index,
                      type: "checkbox",
                      checked: item.selected,
                      onClick: ($event: any) => (item.selected = !item.selected),
                      disabled: item.disabled
                    }, null, 8, _hoisted_11),
                    _createElementVNode("label", {
                      for: 'field-' + index
                    }, [
                      _createTextVNode(_toDisplayString(item.name) + " ", 1),
                      _hoisted_13
                    ], 8, _hoisted_12)
                  ])
                ]))
              }), 128))
            ])
          ]),
          _createElementVNode("div", _hoisted_14, [
            _createElementVNode("button", {
              type: "button",
              class: "btn btn--secontary",
              onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.cancel && _ctx.cancel(...args)))
            }, " Cancel "),
            _createElementVNode("button", {
              type: "button",
              class: "btn btn--primary",
              onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.purchase && _ctx.purchase(...args))),
              disabled: !_ctx.products.some((p) => p.selected)
            }, " Confirm ", 8, _hoisted_15)
          ])
        ]))
      : _createCommentVNode("", true),
    (_ctx.payNow)
      ? (_openBlock(), _createBlock(_component_stripe_checkout, {
          key: 2,
          ref: "checkoutRef",
          mode: "subscription",
          pk: _ctx.publishableKey,
          "session-id": _ctx.sessionId
        }, null, 8, ["pk", "session-id"]))
      : _createCommentVNode("", true)
  ]))
}